import * as React from 'react';
import { Formik } from 'formik';
import * as _ from 'lodash';
import * as Util from 'src/util';
import { Input } from './../Shared/BsInput';

const RenderForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  isSubmitting,
}: any) => {
  return (
    <div>
      <form onSubmit={handleSubmit} autoComplete="off">
        <Input
          label={`Nombre`}
          type="text"
          name={`name`}
          onChange={handleChange}
          value={values.name}
          errors={errors}
        />
        <div className="form-group text-right">
          <button type="submit" className="btn btn-lg btn-dark" disabled={isSubmitting}>
            GUARDAR
          </button>
        </div>
      </form>
    </div>
  );
}

export default class ContentForm extends React.Component<any, any> {
  public render() {
    const { onSubmit, tag }: any = this.props;

    return (
      <div className="card mb-5">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">
            <i className="fa fa-pencil-square"></i> Tags
          </h3>
        </div>
        <div className="card-body">
          {
            <Formik
              initialValues={tag}
              enableReinitialize={true}
              onSubmit={
                async (values: any, { setSubmitting, setErrors }: any) => {
                  try {
                    const cleanValues = _.pick(_.cloneDeep(values), [
                      'name',
                    ]);

                    await onSubmit(Util.replaceEmptyStringWithNull(cleanValues));
                  } catch (err) {
                    if (err.response.data.errors) {
                      setErrors(err.response.data.errors);
                    }

                    setSubmitting(false);
                  }
                }
              }
              render={RenderForm}
            >
            </Formik>
          }

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tags/form.tsx